import { useState } from "react";
import TextFields from "../../components/TextField/text-field.component";

import {
  PreviewOfPaymentModalWrapper,
  PreviewOfPaymentModalContainer,
  PreviewOfPaymentHeader,
  PreviewOfPaymentSubHeader,
  PreviewOfPaymentDetailsModal,
  PreviewOfPaymentInfo,
  Label,
  PreviewEmailContainer,
  PreviewSmallInput,
  PreviewLargeInput,
  PreviewPhoneBox,
  PreviewPaymentPhoneContainer,
  PreviewPaymentInputMain,
  PreviewPaymentInput1,
  PreviewPaymentInput2,
  PreviewPaymentInput3,
  PreviewPaymentInput4,
  PreviewPaymentContent1,
  PreviewPaymentContent2,
  PreviewPaymentContent3,
  PreviewPaymentMainCon,
  SelectPaymentOptionPaymentLink,
  PaymentWithAccount,
  RadioButton,
  PreviewPaymentButtonContainer,
  SpanStyles,
  PaymentOptionsSelect,
  PaymentWithCardSpan,
  PreviewTaxContainer,
  CharityPreviewSubSpan,
} from "./AdhocPreviewOfPayment.styles";

import fipayFonts from "../../theme/index";
import Buttons from "../../components/Button/button.component";
import { colors } from "../../theme/color";

import { GET_ALL_PRODUCTS } from "../../graphql/queries/paymentlink";
import { useQuery } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";

interface ShowCardData {
  showTaxInfo?: any;
  showCharity?: any;
}

const AdhocPreviewOfPayment: React.FC<ShowCardData> = ({ showCharity }) => {
  const [data, setData] = useState({
    quantity: "",
    email: "",
  });

  const {
    loading,
    error,
    data: getAlldata,
  } = useQuery(GET_ALL_PRODUCTS, {
    variables: { service: "payment-link" },
  });

  const selector = useSelector((state: any) => state.products);

  const [phone, setPhone] = useState("");
  const [oneTimeChecked, setOneTimeChecked] = useState(false);
  const [recurringChecked, setRecurringChecked] = useState(false);

  const handleNameChange = (key: string, value: string) => {
    setData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  const handleOneTimeClick = () => {
    setOneTimeChecked(true);
    setRecurringChecked(false);
  };

  const handleRecurringClick = () => {
    setOneTimeChecked(false);
    setRecurringChecked(true);
  };

  const handlePhoneChange = (e: any) => {
    setPhone(e.target.value);
  };

  const dropdownOptions = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
  ];

  return (
    <PreviewOfPaymentModalWrapper>
      <PreviewOfPaymentModalContainer>
        <PreviewOfPaymentHeader>
          Preview of your payment link
        </PreviewOfPaymentHeader>
        <PreviewOfPaymentDetailsModal>
          <PreviewPaymentInputMain>
            <PreviewEmailContainer>
              <TextFields
                height="30px"
                type="number"
                placeholder="$0.00"
                fontSize={fipayFonts.fipayFonts.fontSize.body3}
                label="Amount"
                value={data.quantity}
                onChange={(value: string) =>
                  handleNameChange("quantity", value)
                }
              />
            </PreviewEmailContainer>
          </PreviewPaymentInputMain>

          <SelectPaymentOptionPaymentLink>
            <PaymentOptionsSelect>Select payment option</PaymentOptionsSelect>
            <PaymentWithAccount>
              <RadioButton
                checked={oneTimeChecked}
                onClick={handleOneTimeClick}
              />
              <PaymentWithCardSpan>Pay with account</PaymentWithCardSpan>
            </PaymentWithAccount>
            <PaymentWithAccount>
              <RadioButton
                checked={recurringChecked}
                onClick={handleRecurringClick}
              />
              <PaymentWithCardSpan>Pay with card</PaymentWithCardSpan>
            </PaymentWithAccount>
          </SelectPaymentOptionPaymentLink>
          <PreviewPaymentButtonContainer>
            <Buttons
              // handleClick={NavigateToTypeOfAccount}
              label="Pay"
              width="100%"
              color={colors.ButtonBackgroundColors.primaryMediumHoverButton}
              cursor="pointer"
              border="10px"
              height="45px"
              // disabled={!isFormValid()}
            />
          </PreviewPaymentButtonContainer>
        </PreviewOfPaymentDetailsModal>
      </PreviewOfPaymentModalContainer>
    </PreviewOfPaymentModalWrapper>
  );
};

export default AdhocPreviewOfPayment;
